import apiClient from './api';

export interface AvailableTime {
  startTime: string;
  endTime: string;
}

export interface ReservationPolicy {
  reservable: boolean;
  availableTimes: AvailableTime[];
}

export interface OperationTimeInput {
  name: string;
  startTime: string;
  endTime: string;
}

export interface FacilityUpdateRequest {
  name: string;
  description: string;
  purpose: string;
  equipment: string;
  caution: string;
  location: string;
  thumbnailImage: string;
  category: string;
  operationTimes: OperationTimeInput[];
  images: string[];
  reservationPolicy: ReservationPolicy;
  buildingId: number;
  themeIds: number[];
}

export const adminFacilityService = {
  uploadImage: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<{ url: string }>(
      '/admin/facilities/images',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    return response.data.url;
  },

  createFacility: async (universityId: number, data: FacilityUpdateRequest): Promise<void> => {
    await apiClient.post(`/admin/universities/${universityId}/facilities`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  updateFacility: async (facilityId: number, data: FacilityUpdateRequest): Promise<void> => {
    await apiClient.put(`/admin/facilities/${facilityId}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  deleteFacility: async (facilityId: number): Promise<void> => {
    await apiClient.delete(`/admin/facilities/${facilityId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },
};
